export const submitWithCommit = function(form, commit) {
  form.querySelector('input[name="commit"]')?.remove();
  const hiddenInput = document.createElement('input');
  hiddenInput.type = 'hidden';
  hiddenInput.name = 'commit';
  hiddenInput.value = commit;
  form.appendChild(hiddenInput);
  form.submit();
};
